// extracted by mini-css-extract-plugin
export var aboveInput = "_oa-0";
export var actionButton = "_oa-5";
export var actionButtonContainer = "_oa-1";
export var actionIcon = "_oa-6";
export var aiInfoContainer = "_oa-2";
export var attachmentWrapper = "_oa-7";
export var bold = "_oa-3";
export var checkIcon = "_oa-8";
export var clickingRecipientBar = "_oa-11";
export var commentThreadSwitch = "_oa-a";
export var draftImage = "_oa-b";
export var draftImageContainer = "_oa-c";
export var draftImages = "_oa-e";
export var editButton = "_oa-g";
export var editor = "_oa-f";
export var editorContainer = "_oa-y";
export var editorErrorTooltipWrapper = "_oa-9";
export var headerDivider = "_oa-h";
export var icon = "_oa-i";
export var info = "_oa-j";
export var internal = "_oa-n";
export var internalDivider = "_oa-k";
export var internalMessage = "_oa-l";
export var messageInputCard = "_oa-m";
export var messageInputForm = "_oa-o";
export var messageInputFormInternal = "_oa-p";
export var options = "_oa-q";
export var publicMessageCustomer = "_oa-s";
export var publicMessageMerchant = "_oa-r";
export var removeImageButton = "_oa-d";
export var replyButtons = "_oa-t";
export var showSignatureButton = "_oa-u";
export var spinner = "_oa-v";
export var verticalButtonDivider = "_oa-4";
export var visibilitySelector = "_oa-w";
export var warning = "_oa-x";
export var wrappingText = "_oa-z";
export var writingInternalNoteTopBorder = "_oa-10";